import { inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ApiService } from './api.service';

export interface IndicationEmployee {
  name: string;
  phone: string;
  sector: string;
  email: string;
  city: string;
  state: string;
}

export interface IndicationData {
  name: string;
  companyName: string;
  document: string;
  phone: string;
  email: string;
}

export interface ComplementaryData {
  bestContactTime: string;
  contactMethod: string;
  additionalInfo: string;
  companyAware: boolean;
}

export interface IndicationRequest {
  employee: IndicationEmployee;
  indication: IndicationData;
  complementaryData: ComplementaryData;
}

export interface ChannelIndicationRequest {
  indication: IndicationData;
  complementaryData: ComplementaryData;
  utm: string;
}

export interface IndicationResponse {
  status: string;
  msg: string;
  data: {
    id: number;
    uuid: string;
    employee: IndicationEmployee;
    indication: IndicationData;
    createdAt: string;
    status: string;
  };
  error: boolean;
  errors: string[];
  page: number;
  nextPage: number;
  lastPage: number;
  nextPageUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class IndicationService {
  private readonly API_URL = '/user-indications';
  private readonly CHANNEL_API_URL = '/user-indications/channel';
  private apiService = inject(ApiService);


  submitIndication(indicationData: IndicationRequest): Observable<IndicationResponse> {
    return this.apiService.post<IndicationResponse>(
      this.API_URL,
      indicationData
    );
  }

  submitChannelIndication(
    indicationData: ChannelIndicationRequest
  ): Observable<HttpResponse<IndicationResponse | Record<string, unknown>>> {
    return this.apiService.post<HttpResponse<IndicationResponse | Record<string, unknown>>>(
      this.CHANNEL_API_URL,
      indicationData,
      { observe: 'response' }
    );
  }
}
